import React from 'react';
import { useTranslation } from 'react-i18next';
import { CTALink } from '@components/CTALink';
import { Department, Overlay, DepartmentText, StyledCloudImage } from './ShopRegistrySection.styles';

interface Props {
  title: string;
  image: string;
  link: string;
}

export const ShopRegistryDepartment: React.FC<Props> = ({ title, image, link }) => {
  const { t } = useTranslation('registry');
  return (
    <Department>
      <Overlay>
        <DepartmentText color="mono7" variant="dek24" tagName="h3">
          {title}
        </DepartmentText>
      </Overlay>
      <CTALink id={`RegistryDepartment${title}`} variant="altPurple" href={link} aria-label={`Registry Department ${title}`}>
        <StyledCloudImage
          src={image}
          alt={t('shopRegistry.departmentImageAlt', { department: title })}
          width="100%"
          resizeWidth={326}
          mobileResizeWidth={326}
          optimization="default"
        />
      </CTALink>
    </Department>
  );
};
